module.exports = __webpack_public_path__ + "img/softinya-prop-7.be39deb5.webp";